import { Directory } from "../../../../base/domain/drawing";
import { EditableFormatSummary } from "../../../domain/editableFormat";
import { EditableFormatSummaryDirectoryFilterParameter, EditableFormatSummaryFilterParameter } from ".";

export class EditableFormatSummaryTreeFilterParameter {
  constructor(
    public reference: EditableFormatSummaryFilterParameter = new EditableFormatSummaryFilterParameter(),
    public directory: EditableFormatSummaryDirectoryFilterParameter = new EditableFormatSummaryDirectoryFilterParameter(),
  ) {
  }

  filter(source: EditableFormatSummary | Directory<number, EditableFormatSummary>): boolean {
    if (source instanceof EditableFormatSummary) {
      return this.reference.filter(source);
    } else {
      return this.directory.filter(source);
    }
  }

  clear(): void {
    this.reference = new EditableFormatSummaryFilterParameter();
    this.directory = new EditableFormatSummaryDirectoryFilterParameter();
  }

  clone(): EditableFormatSummaryTreeFilterParameter {
    return new EditableFormatSummaryTreeFilterParameter(
      this.reference.clone(),
      this.directory.clone(),
    );
  }
}
